export default __webpack_public_path__ + "655bea2712a93cb48e0b104906098bcd.png";